import { createRouter, createWebHistory } from "vue-router";
import { abortAll } from "@/api";
import { abortTrackedFetches } from "@/utils/fetchTracker";

const routes = [
  {
    path: "/",
    component: () => import("@/views/VerifyPage.vue"),
    meta: { title: "Verificación" },
  },
  {
    path: "/login",
    component: () => import("@/views/LoginPage.vue"),
    meta: { title: "Intranet - Login" },
  },
  {
    path: "/inicio",
    component: () => import("@/views/InicioPage.vue"),
    meta: { title: "Intranet - Inicio" },
  },

  {
    path: "/super_admin/comunicados",
    component: () => import("@/views/SuperAdminComunicadosPage.vue"),
    meta: { title: "Intranet - Super Admin Comunicados" },
  },
  {
    path: "/super_admin/webinar",
    component: () => import("@/views/SuperAdminWebinarPage.vue"),
    meta: { title: "Intranet - Super Admin Webinar" },
  },
  {
    path: "/super_admin/usuarios",
    component: () => import("@/views/SuperAdminUserIntranetPage.vue"),
    meta: { title: "Intranet - Super Admin User Intranet" },
  },
  {
    path: "/super_admin/proveedores",
    component: () => import("@/views/admin/providers/SuperAdminProveedorPage.vue"),
    meta: { title: "Intranet - Super Admin Proveedor" },
  },
  {
    path: "/super_admin/directorio",
    component: () => import("@/views/SuperAdminDirectorioPage.vue"),
    meta: { title: "Intranet - Super Admin Directorio" },
  },
  {
    path: "/super_admin/flyers",
    component: () => import("@/views/SuperAdminFlyerPage.vue"),
    meta: { title: "Intranet - Super Admin Flyer" },
  },
  {
    path: "/super_admin/sala_de_aprendizaje",
    component: () => import("@/views/SuperAdminSalaAprendizajePage.vue"),
    meta: { title: "Intranet - Super Admin Sala de Aprendizaje" },
  },
  {
    path: "/super_admin/certificaciones",
    component: () => import("@/views/SuperAdminCertificacionesPage.vue"),
    meta: { title: "Intranet - Super Admin Certificaciones" },
  },
  {
    path: "/super_admin/herramientas",
    component: () => import("@/views/SuperAdminHerramientasPage.vue"),
    meta: { title: "Intranet - Super Admin Herramientas" },
  },
  {
    path: "/super_admin/formatos",
    component: () => import("@/views/SuperAdminFormatosPage.vue"),
    meta: { title: "Intranet - Super Admin Formatos" },
  },
  {
    path: "/super_admin/contratos",
    component: () => import("@/views/SuperAdminContratosPage.vue"),
    meta: { title: "Intranet - Super Admin Contratos" },
  },
  {
    path: "/super_admin/agencias_gani",
    component: () => import("@/views/SuperAdminAgenciasGaniPage.vue"),
    meta: { title: "Intranet - Super Admin Agencias Gani" },
  },
  {
    path: "/super_admin/documentos_corporativos",
    component: () => import("@/views/SuperAdminDocumentosPage.vue"),
    meta: { title: "Intranet - Super Admin Documentos" },
  },
  {
    path: "/super_admin/promocionales",
    component: () => import("@/views/SuperAdminPromocionalesPage.vue"),
    meta: { title: "Intranet - Super Admin Promocionales" },
  },

  {
    path: "/chat",
    component: () => import("@/views/ChatPage.vue"),
    meta: { title: "Intranet - Chat" },
  },
  {
    path: "/proveedores",
    component: () => import("@/views/providers/ProveedoresPage.vue"),
    meta: { title: "Intranet - Proveedores" },
  },
  {
    path: "/directorio",
    component: () => import("@/views/directory/DirectorioPage.vue"),
    meta: { title: "Intranet - Directorio" },
  },
  {
    path: "/corporativo",
    component: () => import("@/views/corporate/CorporativoPage.vue"),
    meta: { title: "Intranet - Corporativo" },
  },
  {
    path: "/promocionales",
    component: () => import("@/views/promotional/PromocionalesPage.vue"),
    meta: { title: "Intranet - Promocionales" },
  },
  {
    path: "/flyers",
    component: () => import("@/views/flyers/FlyersPage.vue"),
    meta: { title: "Intranet - Flyers" },
  },
  {
    path: "/herramientas",
    component: () => import("@/views/tools/ToolsPage.vue"),
    meta: { title: "Intranet - Herramientas" },
  },
  {
    path: "/sala_de_aprendizaje",
    component: () => import("@/views/learning_room/SalaAprendizajePage.vue"),
    meta: { title: "Intranet - Sala de Aprendizaje" },
  },
  {
    path: "/capacitaciones",
    component: () => import("@/views/CapacitacionesPage.vue"),
    meta: { title: "Intranet - Capacitaciones" },
  },
  {
    path: "/certificaciones",
    component: () => import("@/views/certifications/CertificacionesPage.vue"),
    meta: { title: "Intranet - Certificaciones" },
  },
  {
    path: "/me",
    component: () => import("@/views/MePage.vue"),
    meta: { title: "Intranet - Me" },
  },
  {
    path: "/capacitaciones/sala",
    component: () => import("@/views/CapacitacionesSalaPage.vue"),
    meta: { title: "Intranet - Capacitaciones Sala" },
  },

  {
    path: "/foros",
    name: "foros",
    component: () => import("@/views/forum/ForumsPage.vue"),
    meta: { title: "Intranet - Foros" },
  },
  {
    path: "/suscripciones",
    name: "suscripciones",
    component: () => import("@/views/forum/SuscriptionList.vue"),
    meta: { title: "Intranet - Suscripciones" },
  },
  {
    path: "/destacadas",
    name: "destacadas",
    component: () => import("@/views/forum/FeaturedAnswerList.vue"),
    meta: { title: "Intranet - Destacadas" },
  },
  {
    path: "/admin-foro",
    name: "admin-view",
    component: () => import("@/views/AdminView.vue"),
    meta: { title: "Intranet - Admin Foro" },
  },

  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/NotFoundPage.vue"),
    meta: { title: "Página no encontrada" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  const defaultTitle = "Intranet";
  document.title = to.meta.title || defaultTitle;
});

// Cancel outstanding API requests when navigating between routes
router.beforeEach((to, from, next) => {
  try {
    abortAll();
    abortTrackedFetches();
  } catch (e) {
    /* ignore */
  }
  next();
});

export default router;
// import { createRouter, createWebHashHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
// import LoginView from '../views/LoginView.vue'

// const routes = [
//   {
//     path: '/',
//     name: 'home',
//     component: HomeView
//   },
//   {
//     path: '/login',
//     name: 'login',
//     component: LoginView
//   },
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   }
// ]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })

// export default router
